module.exports = __webpack_public_path__ + "static/media/HarshArora.ce3d5c31.png";